import { CardBody,Card,CardHeader } from 'reactstrap'
 
export default function NotFound (){
    return (
     <Card>
        <CardHeader>Pagina no encontrada</CardHeader>
        <CardBody>
        </CardBody>
     </Card>
    );
}
